import { Grid, Typography, Button } from "@mui/material";
import { Logout } from "@mui/icons-material";

type Props = {
  title: string;
  loginEventCode: string;
  onLogout: () => void;
};

const RestarterPageHeader = ({ title, loginEventCode, onLogout }: Props) => (
  <Grid container>
    <Grid item xs={12} sm={6}>
      <Typography variant="h5" component="h1" gutterBottom>
        {title}
      </Typography>
    </Grid>
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        display: "flex",
        justifyContent: {
          xs: "flex-start",
          sm: "flex-end",
        },
        gap: 1,
        alignItems: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {loginEventCode}
      </Typography>
      {loginEventCode && (
        <Button
          startIcon={<Logout fontSize="small" />}
          size="small"
          onClick={onLogout}
        >
          Logout
        </Button>
      )}
    </Grid>
  </Grid>
);

export default RestarterPageHeader;
